<p-confirmDialog header="Deleting Lead Document Template"></p-confirmDialog>
<p-table [value]="pdfTemplateService.contactRequestPdfTemplates">
    <ng-template pTemplate="header">
        <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Created by</th>
            <th>Last modified</th>
            <th>Last modified by</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-template>
        <tr>
            <td>{{template.id}}</td>
            <td>
                <a (click)="editSelectedContactRequestTemplate(template)">
                    {{template.name}}
                </a>
            </td>
            <td>
                {{template.createdBy.name}}
            </td>
            <td>
                {{template.lastModified | date:'dd/MM/yyyy HH:mm'}}
            </td>
            <td>
                {{template.lastModifiedBy.name}}
            </td>
            <td>
                <p-button icon="pi pi-trash" styleClass="p-button-danger" (onClick)="deleteTemplate(template.id)"></p-button>
            </td>
        </tr>
    </ng-template>
</p-table>
